class CollapsibleFigures {
    constructor(figures, config) {
        this.figures = figures;
        this.config = config;
        this.init();
    }

    init() {
        this.collapseTmpl = document.getElementById('collapsible_tables_collapse_template');
        this.expandTmpl = document.getElementById('collapsible_tables_expand_template');
        this.keepSession = this.config.retainSessionStatus ?? false;
        this.collapsedClass = this.config.collapsedClass ?? 'collapsed';
        this.collapsingTrigger = this.config.collapsingTrigger ?? '.collapsible-figure-btn';
        this.collapsingElementClass = this.config.collapsingElementClass ?? 'collapsible-wrapper';
        this.wrapClass = this.config.wrap ?? '.figure-wrap';
        this.collapsedHeight = this.config.height ?? '400px';
        this.scrollParentIntoView = this.config.scrollParentIntoView;
        this._makeCollapsibleElements();
    }

    _collapse(wrapper, trigger, parent, initialized) {
        this.buttonTemplate = this.expandTmpl;
        wrapper.classList.add(this.collapsedClass);
        wrapper.style.height = this.collapsedHeight;
        trigger?.setAttribute('aria-expanded', 'false');
        parent.forEach(figureWrap => this._setTableInnerLinksTabIndex('set', figureWrap));
        initialized && this.scrollParentIntoView && wrapper.parentNode.scrollIntoView();
    }

    _expand(wrapper, trigger, parent) {
        this.buttonTemplate = this.collapseTmpl;
        wrapper.classList.remove(this.collapsedClass);
        wrapper.removeAttribute('style');
        trigger?.setAttribute('aria-expanded', 'true');
        parent.forEach(figureWrap => this._setTableInnerLinksTabIndex('remove', figureWrap));
    }

    _collapsibleTrigger(figure, trigger, wrapper, action) {
        const tmpl = this.buttonTemplate.content.cloneNode(true);
        trigger = tmpl.querySelector(this.collapsingTrigger);
        trigger.addEventListener('click', action);
        trigger.setAttribute('aria-controls', figure.id);
        wrapper.parentNode.insertBefore(tmpl, wrapper.nextSibling);
    }

    _collapsibleWrapper(figure, parent) {
        let wrapper = figure.ref.querySelector(this.collapsingElementClass);
        try {
            if (!wrapper && parent[0]?.offsetHeight > parseInt(this.collapsedHeight)) {
                wrapper = document.createElement('div');
                wrapper.classList.add(this.collapsingElementClass);
                parent[0].parentNode.insertBefore(wrapper, parent[0]);
                parent.forEach(table => wrapper.appendChild(table));
            }
        } catch (error) {
            console.error('Add collapsible wrapper', error);
        }
        return wrapper;
    }

    _makeCollapsibleElements() {
        this.figures.map(figure => {
            const figureWraps = figure.ref.querySelectorAll(this.wrapClass);
            const constructedKey = sessionStorage.getItem('doi') + '_' + figure.id + '_figureExpanded';
            const sessionExpanded = this.keepSession ? sessionStorage.getItem(constructedKey) : false;

            if (figureWraps.length > 0) {
                let collapsibleWrapper = this._collapsibleWrapper(figure, figureWraps);
                if (!collapsibleWrapper) return;

                let initialized = false;
                const handleTableExpand = e => {
                    e?.preventDefault();
                    e?.stopPropagation();
                    let togglingButton = collapsibleWrapper.parentNode.querySelector(this.collapsingTrigger);
                    togglingButton?.parentNode.remove();

                    if (
                        collapsibleWrapper.classList.contains(this.collapsedClass) ||
                        (!initialized && sessionExpanded === 'true')
                    ) {
                        this._expand(collapsibleWrapper, togglingButton, figureWraps);
                    } else {
                        this._collapse(collapsibleWrapper, togglingButton, figureWraps, initialized);
                    }
                    if (initialized && this.keepSession) {
                        sessionStorage.setItem(
                            constructedKey,
                            String(!collapsibleWrapper.classList.contains(this.collapsedClass))
                        );
                    }
                    initialized = true;

                    this._collapsibleTrigger(figure, togglingButton, collapsibleWrapper, handleTableExpand);
                    this.extraLogic(figureWraps);
                };

                handleTableExpand();
            }
        });
    }

    _setTableInnerLinksTabIndex(status, figureWrap) {
        const tableInnerLinks = figureWrap.querySelector('table')?.querySelectorAll('a');
        tableInnerLinks?.forEach(a => {
            if (status === 'set') {
                a.setAttribute('tabindex', '-1');
            } else {
                a.removeAttribute('tabindex');
            }
        });
    }

    // Add here any extra logic that is needed for each collapsable table
    extraLogic(figureWraps) {}
}

module.exports = CollapsibleFigures;
